/**
 * Route prefix for JBF-admin application
 * This is used for external references to the admin app (e.g., in src/utils/navigationRoutes.tsx)
 * NOTE: Do NOT use this prefix for internal routing within the Admin app.
 * The app is mounted at /jainboarding-admin/* by the parent router, so internal routes should be relative.
 */
export const ROUTE_PREFIX = "/jainboarding-admin";

/**
 * Helper function to prefix a route path
 */
export const prefixRoute = (path: string): string => {
  if (path.startsWith(ROUTE_PREFIX)) {
    return path;
  }
  if (path.startsWith("/")) {
    return `${ROUTE_PREFIX}${path}`;
  }
  return `${ROUTE_PREFIX}/${path}`;
};
